import { observable } from "@legendapp/state";
import type { SharedStore } from "./index.d";

export const sharedStore = observable<SharedStore>({
  auth: null,
  dateOfBirth: "",
  phone: "",
  drivingExperience: -1,
  selectedCar: null,
  selectedTractor: null,
});

export type { AuthData, SharedStore } from "./index.d";
